/* eslint-disable prefer-template */
import React, { useState, useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet-async';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// @mui
import {
    Card,
    Stack,
    Paper,
    Avatar,
    Button,
    Container,
    Typography,
    IconButton,
    TablePagination,
    ListItemIcon,
    Box,
    TextField,
    Tooltip,
    InputAdornment

} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import SearchIcon from '@mui/icons-material/Search';


import Grid from '@mui/material/Grid';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';


// table
// eslint-disable-next-line import/order
import { apiUrl } from '../utils/api';
import MUIDataTable from 'mui-datatables';
import { Navigate, useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import { AlertDialog } from '../utils/dealog/diloag';
// user Api
import { useGetDeliverListApiMutation, useDeliverSearchApiMutation } from '../redux/services/delivery/delivery';
// ----------------------------------------------------------------------
const columns = [
    {
        name: 'profile',
        label: 'Profile ',

    }, {
        name: 'name',
        label: 'Name',

    },
    {
        name: 'mobile',
        label: 'Mobile',

    },


];






const DataLogo = ({ name, path, id }) => {
    const url = `${apiUrl.deliverprofile}${path}`;
    console.log("deliverProfile", url)
    return (
        <Avatar alt={name} src={url} />

    )
}

const UserFirstName = ({ firstName, id, lastName }) => {
    return (
        <>
            <Button variant="text" component={RouterLink} to={`/delivery-orders/${id}`}>{firstName} {lastName}</Button>
        </>
    )
}



const UserMobileNo = ({ mobileNo }) => {
    return (
        <>
            <Typography variant="body1">{mobileNo}</Typography>
        </>
    )
}







export default function DeliverPage() {
    // user ApiRedux
    const [deliveryListData, deliverload] = useGetDeliverListApiMutation()
    const [deliverSearch] = useDeliverSearchApiMutation()

    const [loadData, setLoadData] = useState(false)
    const [deliveryListRow, setdeliveryListRow] = useState([]);
    const [totalPage, setTotalPage] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    // const rowsPerPage = 10;
    const [searchByMobile, setSearchByMobile] = useState("");

    const deliveryList = async () => {

        const body = {
            page: currentPage
        }
        try {

            const result = await deliveryListData(body)
            if (result && result.data.list) {
                const data = result.data.list.map((item) => ({
                    profile: <DataLogo path={item.profile_thumb} />,
                    name: <UserFirstName firstName={item.first_name} id={item.id} lastName={item.last_name} />,
                    mobile: <UserMobileNo mobileNo={item.mobile} />,
                }));
                setdeliveryListRow(data);
            } else {
                console.error("Invalid API response:", result);
            }
            console.log("deliveryList", result.data.list)
            setTotalPage(result?.data?.total);
            setCurrentPage(result?.data?.current);



        } catch (error) {
            console.error("Error fetching data:", error);

        }
    }



    const onDeliverySearch = async (mobile) => {

        try {
            const search = {
                mobile: mobile,
            };

            const userSearchResult = await deliverSearch(search);
            const searchResults = userSearchResult.data.list.map((item) => ({
                profile: <DataLogo path={item.profile_thumb} />,
                name: <UserFirstName firstName={item.first_name} id={item.id} lastName={item.last_name} />,
                mobile: <UserMobileNo mobileNo={item.mobile} />,
            }));
            setdeliveryListRow(searchResults);
            console.log('search', searchResults);


        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoadData(false);
        }
    };

    const options = {
        filterType: 'dropdown',
        selectableRows: "multiple",
        responsive: "vertical",
        serverSide: true,
        count: totalPage,
        page: currentPage,
        onTableChange: (action, tableState) => {
            if (action === 'changePage') {

                setCurrentPage(tableState.page + currentPage);
            }
        },
    };









    const handleSearchMobile = (event) => {
        const value = event.target.value;
        setSearchByMobile(value);

        const is10DigitNumber = /^\d{10}$/.test(value);

        if (is10DigitNumber) {
            onDeliverySearch(`+91${value}`);
        } else if (value.trim() === '') {
            setSearchByMobile('');
            deliveryList();
        } else {
            onDeliverySearch(value);
        }
        // if (value.trim() === '') {
        //     setSearchByMobile('');
        //     deliveryList();
        // } else {
        //     onDeliverySearch(value,);
        // }
    };


    useEffect(() => {
        deliveryList()
    }, [loadData])








    return (
        <>
            <Helmet>
                <title> Delivery | Minimal UI </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Delivery
                    </Typography>
                    <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
                        New Delivery
                    </Button>
                </Stack>
                <Card>
                    <Box sx={{ flexGrow: 1, margin: "30px", }} >

                        <Box sx={{ display: 'flex', justifyContent: "end" }}>
                            <TextField
                                id="outlined-basic"
                                label="Search By MobileNo"
                                variant="outlined"
                                size="small"
                                value={searchByMobile}
                                onChange={handleSearchMobile}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton aria-label="search"  >
                                                <SearchIcon sx={{ color: 'blue' }} />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>


                    </Box>
                </Card>
                <br />
                <br />
                {deliverload.isLoading ? <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : (
                    <Card>
                        <MUIDataTable title={'Delivery'} data={deliveryListRow} columns={columns} options={options} />
                    </Card>
                )}
            </Container>



        </>
    );
}
